// extracted by mini-css-extract-plugin
export default {"body":"body__9b33999b","header":"header__9b33999b"};